import { NgModule } from '@angular/core';

// PrimeNG Modules
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  exports: [
    ButtonModule,
    SidebarModule,
    TieredMenuModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    ToastModule,
    DialogModule,
    // Agrega aquí más módulos según lo necesites
  ]
})
export class PrimeNgModule { }